import { cn } from "@istari-frontend/shared";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const statusIndicatorVariants = cva("flex h-4 w-4 items-center justify-center transition-opacity duration-150", {
  variants: {
    size: {
      sm: "[&_.indicator]:size-2",
      md: "[&_.indicator]:size-2.5",
      lg: "[&_.indicator]:size-3",
    },
    variant: {
      blue: "[&_.ripple-1]:bg-primary/20 [&_.ripple-2]:bg-primary/10 [&_.dot]:bg-primary",
      gray: "[&_.ripple-1]:bg-muted-foreground/20 [&_.ripple-2]:bg-muted-foreground/10 [&_.dot]:bg-muted-foreground",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "blue",
  },
});

interface StatusIndicatorProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof statusIndicatorVariants> {}

export const StatusIndicator = React.forwardRef<HTMLDivElement, StatusIndicatorProps>(
  ({ className, size, variant, ...props }, ref) => {
    return (
      <div ref={ref} className={cn(statusIndicatorVariants({ size, variant }), className)} {...props}>
        <div className="indicator relative">
          {/* Ripple animation */}
          <div
            className="ripple-1 absolute inset-0 animate-ping rounded-full"
            style={{
              animationDuration: "3s",
              animationIterationCount: "infinite",
            }}
          />
          <div
            className="ripple-2 absolute inset-0 animate-ping rounded-full"
            style={{
              animationDuration: "3s",
              animationDelay: "1.5s",
              animationIterationCount: "infinite",
            }}
          />
          {/* Main circle */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="dot size-1.5 rounded-full" />
          </div>
        </div>
      </div>
    );
  },
);

StatusIndicator.displayName = "StatusIndicator";
